import styled from 'styled-components/macro';

export const StyledPlatformCards = styled.div`
  width: 50%;
  padding: 10px;
  :not(:last-child) {
    margin-bottom: 0;
  }
`;
